
<input class="common_hidden_autofill" [type]="type || 'password'" tabindex="-1">